<div class="integrations-list-container">
  <h1 class="tw-text-2xl tw-font-bold tw-text-gray-800 dark:tw-text-gray-100 tw-my-0">
    Live Data Integrations
  </h1>
  <div class="content-description tw-text-gray-700 dark:tw-text-gray-300">
    Live Data integrations provide an easy way to get data into, and export data from, your ledgers
    in a variety of systems.
  </div>
  <div class="content tw-mt-6 tw-flex-col">
    <nav mat-tab-nav-bar [tabPanel]="tabPanel">
      <a
        mat-tab-link
        routerLinkActive="active-tab-nav"
        routerLink="./available-integrations"
        class="tw-text-base">
        Available Integrations
      </a>
      <a
        mat-tab-link
        routerLinkActive="active-tab-nav"
        routerLink="./configured-integrations"
        class="tw-text-base">
        Configured Integrations
      </a>
    </nav>
    <div mat-tab-nav-panel #tabPanel>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
